<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { useModalContext } from './modal.vue'
  import { cn } from '../../lib/utils'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()

  const { modalType } = useModalContext()
</script>

<template>
  <div
    :data-modal-type="modalType"
    :class="
      cn(
        'data-[modal-type=dialog]:p-5 data-[modal-type=drawer]:p-5 data-[modal-type=inline]:p-0',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
